var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_20745",
    "data-name": "Group 20745",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 180.071,
    height: 145.414,
    viewBox: "0 0 180.071 145.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fafdff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20739",
    "data-name": "Group 20739",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16331",
    "data-name": "Path 16331",
    d: "M12734.53-13861.75s-107.3-50.017-79.8-105.012,117.193-45.9,151.688-19.521,27.725,68.127,4.267,87.5S12734.53-13861.75,12734.53-13861.75Z",
    transform: "translate(-12650.221 14007.164)",
    opacity: 0.74,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20738",
    "data-name": "Group 20738",
    transform: "translate(45.862 25.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20731",
    "data-name": "Group 20731",
    transform: "translate(0 43.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20730",
    "data-name": "Group 20730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20729",
    "data-name": "Group 20729"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16310",
    "data-name": "Path 16310",
    d: "M1707.485,320.46l32.9,14.3-12.873,9.3-28.607-14.3,8.582-9.3",
    transform: "translate(-1654.92 -319.03)",
    fill: "#f8fcff",
    stroke: "#b4d6fc",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16311",
    "data-name": "Path 16311",
    d: "M1642.743,394.6l.7-33.749,31.24,14.512v33.788Z",
    transform: "translate(-1631.411 -336.032)",
    fill: "#f8fcff",
    stroke: "#b4d6fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16312",
    "data-name": "Path 16312",
    d: "M1697.5,408.73l31.4-15.116-1-33.176L1697.5,375.1Z",
    transform: "translate(-1654.333 -335.765)",
    fill: "#f8fcff",
    stroke: "#b4d6fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16313",
    "data-name": "Path 16313",
    d: "M1726.995,361.053l12.873,8.582-32.9,15.019-9.3-9.3Z",
    transform: "translate(-1654.405 -336.022)",
    fill: "#f8fcff",
    stroke: "#b4d6fc",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16314",
    "data-name": "Path 16314",
    d: "M1636.955,360.438l-10.012,8.582,32.54,14.661,8.582-8.582Z",
    transform: "translate(-1624.797 -335.765)",
    fill: "#f8fcff",
    stroke: "#b4d6fc",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16315",
    "data-name": "Path 16315",
    d: "M1623.252,333.376,1656.507,318l10.728,10.728-31.825,13.946Z",
    transform: "translate(-1623.252 -318)",
    fill: "#f8fcff",
    stroke: "#b4d6fc",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_16316",
    "data-name": "Path 16316",
    d: "M1644.311,350.433l31.425-13.782,28.136,14.055-28.888,14.038Z",
    transform: "translate(-1631.784 -325.703)",
    fill: "#e3efff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_897",
    "data-name": "Line 897",
    x1: 0.808,
    y2: 29.336,
    transform: "translate(43.175 10.37)",
    fill: "none",
    stroke: "#b4d6fc",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20737",
    "data-name": "Group 20737",
    transform: "translate(32.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16317",
    "data-name": "Path 16317",
    d: "M1688.691,286.939s-6.587,1.238-8.863,7.146c-2.4,6.231.776,11.724,5.828,12.416,2.915.4,4.017-2.694.8-3.752-2.915-.958-10.184-.464-10.938,6.467-.791,7.266,6.866,10.739,6.327,17.026-.275,3.205-3.523,5.891-7.119,6.663s-8.856,4.378-7.431,9.017,6.727,10.935,6.727,10.935",
    transform: "translate(-1667.056 -284.116)",
    fill: "none",
    stroke: "#75b1f2",
    strokeWidth: 1,
    strokeDasharray: 1.395
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20736",
    "data-name": "Group 20736",
    transform: "translate(19.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16318",
    "data-name": "Path 16318",
    d: "M1715.572,284.349c-.518-1.6-3.982-1.027-3.306,1.067S1716.089,285.953,1715.572,284.349Z",
    transform: "translate(-1710.381 -282.647)",
    fill: "#75b1f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20733",
    "data-name": "Group 20733"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16319",
    "data-name": "Path 16319",
    d: "M1709.088,283.14c.026-.7,1-1.244,2.387-.995a7.759,7.759,0,0,1,2.685,1.181,7.722,7.722,0,0,1-2.765.984C1710,284.458,1709.062,283.847,1709.088,283.14Z",
    transform: "translate(-1709.087 -282.084)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20732",
    "data-name": "Group 20732",
    transform: "translate(0.771 0.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16320",
    "data-name": "Path 16320",
    d: "M1714.715,284.107c-.718.005-1.435-.019-2.152-.041s-1.433-.059-2.149-.117c.718-.005,1.435.019,2.152.041S1714,284.049,1714.715,284.107Z",
    transform: "translate(-1710.414 -283.298)",
    fill: "#75b1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16321",
    "data-name": "Path 16321",
    d: "M1711.478,282.83a5.588,5.588,0,0,1,.593.327,5.49,5.49,0,0,1,.553.391,5.7,5.7,0,0,1-.593-.327A5.758,5.758,0,0,1,1711.478,282.83Z",
    transform: "translate(-1710.859 -282.83)",
    fill: "#75b1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16322",
    "data-name": "Path 16322",
    d: "M1713.852,284.107a6.616,6.616,0,0,1-1.192.767,6.192,6.192,0,0,1,.575-.415A6.31,6.31,0,0,1,1713.852,284.107Z",
    transform: "translate(-1711.354 -283.365)",
    fill: "#75b1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16323",
    "data-name": "Path 16323",
    d: "M1715.07,283.426a1.486,1.486,0,0,1,.286.182,1.442,1.442,0,0,1,.238.241,1.418,1.418,0,0,1-.286-.182A1.394,1.394,0,0,1,1715.07,283.426Z",
    transform: "translate(-1712.363 -283.079)",
    fill: "#75b1f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20735",
    "data-name": "Group 20735",
    transform: "translate(1.148 2.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16324",
    "data-name": "Path 16324",
    d: "M1711.232,288.833c.432.555,1.542.422,2.517-.59a7.75,7.75,0,0,0,1.487-2.528,7.732,7.732,0,0,0-2.817.819C1711.2,287.232,1710.8,288.275,1711.232,288.833Z",
    transform: "translate(-1711.062 -285.716)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20734",
    "data-name": "Group 20734",
    transform: "translate(0.778 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16325",
    "data-name": "Path 16325",
    d: "M1715.8,285.717c-.585.416-1.152.854-1.722,1.291s-1.128.886-1.674,1.352c.585-.416,1.153-.855,1.721-1.292S1715.25,286.182,1715.8,285.717Z",
    transform: "translate(-1712.401 -285.717)",
    fill: "#75b1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16326",
    "data-name": "Path 16326",
    d: "M1713.919,289.647a5.646,5.646,0,0,0,.29-.612,5.71,5.71,0,0,0,.22-.64,6.048,6.048,0,0,0-.51,1.252Z",
    transform: "translate(-1713.036 -286.838)",
    fill: "#75b1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16327",
    "data-name": "Path 16327",
    d: "M1714.774,287.614a6.141,6.141,0,0,0-.71,0,6.28,6.28,0,0,0-.706.075,6.163,6.163,0,0,0,.71,0A6.3,6.3,0,0,0,1714.774,287.614Z",
    transform: "translate(-1712.802 -286.507)",
    fill: "#75b1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16328",
    "data-name": "Path 16328",
    d: "M1716.483,287.5a1.5,1.5,0,0,0,.178-.649,1.437,1.437,0,0,0-.126.315A1.46,1.46,0,0,0,1716.483,287.5Z",
    transform: "translate(-1714.11 -286.19)",
    fill: "#75b1f2"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_16329",
    "data-name": "Path 16329",
    d: "M1717.443,284.158a.608.608,0,1,1,.391-.765A.607.607,0,0,1,1717.443,284.158Z",
    transform: "translate(-1712.252 -282.456)",
    fill: "#75b1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16330",
    "data-name": "Path 16330",
    d: "M1718.085,286.148a.608.608,0,1,1,.391-.765A.608.608,0,0,1,1718.085,286.148Z",
    transform: "translate(-1712.521 -283.288)",
    fill: "#75b1f2"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_20740",
    "data-name": "Group 20740",
    transform: "translate(146.543 68.137)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_899",
    "data-name": "Line 899",
    x2: 3.227,
    transform: "translate(0 1.614)",
    fill: "none",
    stroke: "#75b1f2",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_900",
    "data-name": "Line 900",
    x2: 3.227,
    transform: "translate(1.614 0) rotate(90)",
    fill: "none",
    stroke: "#75b1f2",
    strokeLinecap: "round",
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_20741",
    "data-name": "Group 20741",
    transform: "translate(157.677 84.619)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_899-2",
    "data-name": "Line 899",
    x2: 3.227,
    transform: "translate(0 1.614)",
    fill: "none",
    stroke: "#75b1f2",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_900-2",
    "data-name": "Line 900",
    x2: 3.227,
    transform: "translate(1.614 0) rotate(90)",
    fill: "none",
    stroke: "#75b1f2",
    strokeLinecap: "round",
    strokeWidth: 2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_20742",
    "data-name": "Group 20742",
    transform: "translate(24.211 79.694)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_899-3",
    "data-name": "Line 899",
    x2: 3.227,
    transform: "translate(0 1.614)",
    fill: "none",
    stroke: "#75b1f2",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_900-3",
    "data-name": "Line 900",
    x2: 3.227,
    transform: "translate(1.614 0) rotate(90)",
    fill: "none",
    stroke: "#75b1f2",
    strokeLinecap: "round",
    strokeWidth: 2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_20744",
    "data-name": "Group 20744",
    transform: "translate(9.068 99.935)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_899-4",
    "data-name": "Line 899",
    x2: 3.227,
    transform: "translate(0 1.614)",
    fill: "none",
    stroke: "#75b1f2",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_900-4",
    "data-name": "Line 900",
    x2: 3.227,
    transform: "translate(1.614 0) rotate(90)",
    fill: "none",
    stroke: "#75b1f2",
    strokeLinecap: "round",
    strokeWidth: 2
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_20743",
    "data-name": "Group 20743",
    transform: "translate(1.639 82.921)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_899-5",
    "data-name": "Line 899",
    x2: 3.227,
    transform: "translate(0 1.614)",
    fill: "none",
    stroke: "#75b1f2",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_900-5",
    "data-name": "Line 900",
    x2: 3.227,
    transform: "translate(1.614 0) rotate(90)",
    fill: "none",
    stroke: "#75b1f2",
    strokeLinecap: "round",
    strokeWidth: 2
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_466",
    "data-name": "Ellipse 466",
    transform: "translate(149.947 77.456)",
    fill: "none",
    stroke: "#75b1f2",
    strokeWidth: 2,
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.702,
    cy: 1.702,
    r: 1.702,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.702,
    cy: 1.702,
    r: 0.702,
    fill: "none"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_468",
    "data-name": "Ellipse 468",
    transform: "translate(14.087 73.785)",
    fill: "none",
    stroke: "#75b1f2",
    strokeWidth: 2,
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.702,
    cy: 1.702,
    r: 1.702,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.702,
    cy: 1.702,
    r: 0.702,
    fill: "none"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_469",
    "data-name": "Ellipse 469",
    transform: "translate(15.789 89.365)",
    fill: "none",
    stroke: "#75b1f2",
    strokeWidth: 2,
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.702,
    cy: 1.702,
    r: 1.702,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.702,
    cy: 1.702,
    r: 0.702,
    fill: "none"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_467",
    "data-name": "Ellipse 467",
    transform: "translate(141.885 86.145)",
    fill: "none",
    stroke: "#75b1f2",
    strokeWidth: 2,
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.702,
    cy: 1.702,
    r: 1.702,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.702,
    cy: 1.702,
    r: 0.702,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/NoData.7a88a377ff5978159a951867df36b438.svg";
export { ForwardRef as ReactComponent };